import { render, staticRenderFns } from "./ImaginaryUpgradesTab.vue?vue&type=template&id=6888454f&scoped=true"
import script from "./ImaginaryUpgradesTab.vue?vue&type=script&lang=js"
export * from "./ImaginaryUpgradesTab.vue?vue&type=script&lang=js"
import style0 from "./ImaginaryUpgradesTab.vue?vue&type=style&index=0&id=6888454f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888454f",
  null
  
)

export default component.exports